import type { RouteObject } from "react-router-dom";
import PagePassword from "./page-password";
import PageUser from "./page-user";
import PageUsers from "./page-users";

export function RouterUsers(): RouteObject[] {
  return [
    // Routes
    { path: "/user", element: <PageUsers /> },
    { path: "/user/:id", element: <PageUser /> },
    { path: "/user/:id/password", element: <PagePassword /> },
    { path: "/profile", element: <PageUser profile={true} /> },
    { path: "/profile/password", element: <PagePassword profile={true} /> }
  ];
}
